import React, { useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import axios from "../../../api/axios";
import Select from "react-select";
import { AuthContext } from "../../../context/auth";
import Error403 from "../../../components/Error/403";

export const OthersAccountIndexAdd = ({ loggedInUser }) => {
  const [formData, setFormData] = useState({
    recordName: "",
    recordType: "debit",
    paymentMethod: "",
    paymentDate: "",
    amount: "",
    status: "",
    note: "",
    category: "",
  });

  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [recordTypeOptions, setRecordTypeOptions] = useState([]); // Store options for recordType

  // Payment method options
  const paymentMethodOptions = [
    { value: "Cash", label: "Cash" },
    { value: "Bank", label: "Bank" },
  ];

  useEffect(() => {
    // Fetch subcategories for "Others" category
    const fetchRecordTypes = async () => {
      try {
        const response = await axios.get("/get-other-category");
        // Transform response data to react-select format
        const options = response.data.subCategories.map((sub) => ({
          value: sub.name,
          label: sub.name,
        }));

        // Add static categories
        const staticCategories = [
          { value: "Trading", label: "Trading" },
          { value: "Rent", label: "Rent" },
          {
            value: "Travel allowance & entertainment",
            label: "Travel allowance & entertainment",
          },
          {
            value: "Sales Salaries and Commission",
            label: "Sales Salaries and Commission",
          },
          {
            value: "Cost of good sold for cutting and random",
            label: "Cost of good sold for cutting and random",
          },
          {
            value: "Cost of good sold for trading",
            label: "Cost of good sold for trading",
          },
          {
            value: "Cost of good sold for job work",
            label: "Cost of good sold for job work",
          },
          { value: "Sales Office Salaries", label: "Sales Office Salaries" },
          { value: "Advertising Expense", label: "Advertising Expense" },
          {
            value: "Flight and Transportation",
            label: "Flight and Transportation",
          },
          {
            value: "Shipping Supplies and expenses",
            label: "Shipping Supplies and expenses",
          },
          { value: "Postage and Stationery", label: "Postage and Stationery" },
          {
            value: "Telephone and Internet Expenses",
            label: "Telephone and Internet Expenses",
          },
          {
            value: "Depreciation of Sales Equipment",
            label: "Depreciation of Sales Equipment",
          },
        ];

        // Merge API options with static categories
        const mergedOptions = [...options, ...staticCategories];

        setRecordTypeOptions(mergedOptions);
      } catch (error) {
        console.error("Error fetching record types:", error);
        toast.error("Failed to load record types");
      }
    };

    fetchRecordTypes();
  }, []);

  if (user) {
    const access = user.user?.role.find((role) => role.name === "accountOther");
    if (!access || !access.allow) {
      return <Error403 />;
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post("/add-other-account", {
        ...formData,
        user_id: loggedInUser,
      });
      toast.success("Account added successfully");

      // Reset form after submission
      setFormData({
        recordName: "",
        recordType: "",
        paymentMethod: "",
        paymentDate: "",
        amount: "",
        status: "",
        note: "",
      });
    } catch (error) {
      console.error("Error adding account:", error);
      toast.error("Failed to add account");
    }
  };

  return (
    <div className="">
      <section className="content">
        <div className="container">
          <div className="row">
            <div className="">
              <Link
                to="/account/others"
                className="btn btn-primary float-right"
              >
                See All Records
              </Link>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-md-12">
              <div className="card shadow p-3 mb-5 bg-body rounded">
                <div className="card-header">
                  <h3 className="card-title">Add Other Record</h3>
                </div>
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row mb-2">
                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="recordName">Record Name</label>
                          <input
                            type="text"
                            className="form-control"
                            id="recordName"
                            name="recordName"
                            value={formData.recordName}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="recordType2">Record Type</label>
                          <select
                            className="form-select"
                            id="recordType2"
                            name="recordType"
                            value={formData.recordType}
                            onChange={handleInputChange}
                            required
                          >
                            <option value={""} disabled>
                              Select One
                            </option>
                            <option value={"debit"}>Debit</option>
                            <option value={"credit"}>Credit</option>
                          </select>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="cat1">Record Category</label>
                          <Select
                            options={recordTypeOptions} // Set options from API
                            value={{
                              value: formData.category,
                              label:
                                formData.category || "Select Record Category",
                            }}
                            onChange={(selectedOption) =>
                              setFormData({
                                ...formData,
                                category: selectedOption.value,
                              })
                            }
                            placeholder="Select Category"
                            required
                          />
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="paymentMethod">Payment Method</label>
                          <Select
                            options={paymentMethodOptions}
                            value={{
                              value: formData.paymentMethod,
                              label:
                                formData.paymentMethod ||
                                "Select Payment Method",
                            }}
                            onChange={(selectedOption) =>
                              setFormData({
                                ...formData,
                                paymentMethod: selectedOption.value,
                              })
                            }
                            placeholder="Select Payment Method"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row mb-2">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="paymentDate">Payment Date</label>
                          <input
                            type="date"
                            className="form-control"
                            id="paymentDate"
                            name="paymentDate"
                            value={formData.paymentDate}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="amount">Amount</label>
                          <input
                            type="number"
                            className="form-control"
                            id="amount"
                            name="amount"
                            value={formData.amount}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="status">Status</label>
                          <Select
                            options={[
                              { value: "Pending", label: "Pending" },
                              { value: "Completed", label: "Completed" },
                              { value: "Failed", label: "Failed" },
                            ]}
                            value={{
                              value: formData.status,
                              label: formData.status || "Select Status",
                            }}
                            onChange={(selectedOption) =>
                              setFormData({
                                ...formData,
                                status: selectedOption.value,
                              })
                            }
                            placeholder="Select Status"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row mb-2">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor="note">Note</label>
                          <textarea
                            className="form-control"
                            id="note"
                            name="note"
                            value={formData.note}
                            onChange={handleInputChange}
                            rows="3"
                          />
                        </div>
                      </div>
                    </div>

                    <button type="submit" className="btn btn-primary">
                      Add Record
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
